module.exports = __webpack_public_path__ + "statics/img/cate5-1@2x.0e6a708f.png";